import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { environment } from '../../../environments/environment';
import { SessionService, TokenData } from '../../services/ssession.service';
import { CommonModule } from '@angular/common';
import { HideMenuDirective } from './hide-menu.directive';
import { Store } from '@ngrx/store';
import { selectUnconfirmedDocCount } from '../../store/selectors/app.selectors';
import { loadUnconfirmedDocCount } from '../../store/actions/app.actions';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    RouterLink,
    RouterLinkActive,
    CommonModule,
    HideMenuDirective
  ],
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

  public name = 'w Dębicy';

  public desc = environment.description;

  public production = environment.production;

  public showUELogo = environment.topRightUELogoEnabled;

  public authed: boolean = SessionService.Authed();

  public tokenData: TokenData | null = SessionService.GetTokenData();

  public dataCompleted: boolean = SessionService.IsCompletedUserData();

  private store$ = inject(Store);

  public unreadMessageCount = this.store$.selectSignal(selectUnconfirmedDocCount);

  private router: Router = inject(Router);

  public get appLogoPath(): string {
    return `url(${environment.appLogoTopUrl})`;
  }

  public toggleGovMenuNav(): void {
    if (document.body.classList.contains('js-show-gov-menu')) {
      this.hideMenu();
    } else {
      this.showMenu();
    }
  }

  public hideMenu(): void {
    setTimeout(() => {
      document.body.classList.remove('js-show-gov-menu');
    });
  }

  public showMenu(): void {
    setTimeout(() => {
      document.body.classList.add('js-show-gov-menu');
    });
  }

  public onLoginSSO(): void {
    SessionService.SetGoBackUrl(this.router.url);
  }

  public ngOnInit(): void {
    this.store$.dispatch(loadUnconfirmedDocCount());
  }
}
